import { createMutation, useQueryClient } from '@tanstack/solid-query'
import { itemsQueryKey } from '~/resources/items'
import { progressesQueryKey } from '~/resources/progresses'
import { unlockedTreesQueryKey } from '~/resources/unlocked-trees'
import { api, getCurrentUserId } from '~/services/api'
import { deriveRewardPresentation } from '~/lib/derive-reward-presentation'
import { preloadRewardImages } from '~/lib/preload-reward-images'
import { getRewardTreeAssets } from '~/lib/reward-tree-assets'
import type { ClaimRewardResponse } from '~/lib/reward-types'

export const useClaimReward = () => {
  const queryClient = useQueryClient()
  return createMutation(() => ({
    mutationFn: async (progressId: number) => {
      const userId = await getCurrentUserId()
      const response = await api.service
        .put(`challenge/users/${userId}/progresses/${progressId}/reward`)
        .json<ClaimRewardResponse>()

      const draw = response.draw_results?.[0]
      if (draw) {
        const presentation = deriveRewardPresentation(draw)
        await preloadRewardImages(getRewardTreeAssets(presentation.treeGid))
      }
      return response
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: progressesQueryKey })
      queryClient.invalidateQueries({ queryKey: itemsQueryKey })
      queryClient.invalidateQueries({ queryKey: unlockedTreesQueryKey })
    },
  }))
}
